<template>
    <div v-if="hasText && show_description" class="container mx-auto flex flex-col my-10 pagetext-content">
        <h2 v-if="shouldSwitchHeadingTag">
            More information about Recruitment {{ locationTitle }}
        </h2>
        <h2 v-else>
            More Information
        </h2>

        <ReadMore :text="bottomText" class="page-description page-description-bottom"></ReadMore>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ReadMore from 'Components/PageText/ReadMore';

export default {
    name: 'BottomText',
    components: {
        ReadMore
    },
    computed: {
        ...mapState('pagetext', ['bottomText', 'show_description', 'location_name']),
        ...mapGetters('search', ['shouldSwitchHeadingTagForPath']),
        shouldSwitchHeadingTag() {
            return this.shouldSwitchHeadingTagForPath(this.$route.path);
        },
        locationTitle() {
            return this.location_name != '' ? 'in ' + this.location_name : '';
        },
        hasText() { return this.bottomText != ''; }
    },
    mounted() {
    }
}
</script>
